import { CheckCircle, RadioButtonUnchecked, Redeem } from "@mui/icons-material";
import { Step, StepLabel, Stepper } from "@mui/material";
import useCart from "../utils/useCart";
import useIsLearnyDays from "../utils/useIsLearnyDays";


export default function Timeline(){
    const isLearnyDays = useIsLearnyDays();

    const { cart } = useCart();

    if(isLearnyDays) return <></>;

    return window.innerWidth > 1000 &&

        <Stepper activeStep={cart.dpcStep} sx={{mb: 2}}>

            <Step>
                <StepLabel StepIconComponent={CustomStepIcon}>
                    1ère formation
                </StepLabel>
            </Step>

            <Step>
                <StepLabel StepIconComponent={CustomStepIcon}>
                    2ème formation
                </StepLabel>
            </Step>


            <Step>
                <StepLabel StepIconComponent={RedeemIcon}>
                    Obtenez votre récompense
                </StepLabel>
            </Step>


        </Stepper>

}

function CustomStepIcon({ active, completed }){
  
    return completed ?
        <CheckCircle color="info" /> :
        <RadioButtonUnchecked color={active ? 'info' : 'action'} />
        
};

function RedeemIcon({ completed }){

    return <Redeem color={completed ? 'info' : 'action'} />
}